import { Collection, Select, MultilineInput, NumberInput, TextInput } from "@tblabs/truffle";
import { DateTimeEditInput } from "../../../../Components/Utils/DateSlider";
import { PackageToCustomerStep } from "../../../../Steps/PackageToCustomer/PackageToCustomerStep";
import { Step } from "../../../../Steps/Step/Step";
import { Entry } from "./Entry";
import { BasketItemsSelector } from "./BasketItemsSelector";


export class PackageToCustomerEntryEditBox extends Entry<Step<any>>
{
    constructor(step: PackageToCustomerStep, steps: Collection<Step<any>>)
    {
        super(step, steps, []);
        // this.SetTitle(step.GetFullTitle(), step.Data.State.value + ", do " + TimeUtils.FormattedDateTime(step.Timeout));
        this.SetTitle(step.GetFullTitle(), step.GetStateName());

        this.AddField("Przedmioty", new BasketItemsSelector(step.Order.BasketItems, step.Data.PackageContent));
        this.AddInput("Stan", new Select(step.Data.State, step.AllStates));
        this.AddField("Planowany czas nadania", new DateTimeEditInput(step.Data.PlannedDispatchTime));
        this.AddField("Realny czas nadania", new DateTimeEditInput(step.Data.DispatchTime));
        this.AddInput("Adres", new MultilineInput(step.Data.AddressFullInfo).Rows(5));
        this.AddInput("Płatność przy odbiorze", new NumberInput(step.Data.PaymentAtDelivery));
        this.AddInput("Numer paczki", new TextInput(step.Data.PackageNumber));
        this.AddInput("Przewoźnik", new Select(step.Data.Carrier, ["Pocztex", "Inpost", "Uber"]));
        this.AddInput("Koszt paczki", new NumberInput(step.Data.PackageCost));
    }
}
